import { samoletAuthConfig } from '../config';
import { type ISIDTokenResponse, ISamoletConfiguration } from '../types';
import { authApiClient } from './client';

export async function fetchAccessAuthToken(params: {
  config: ISamoletConfiguration;
  code: string;
  verifier: string;
}): Promise<ISIDTokenResponse> {
  const formData = new FormData();

  formData.append('grant_type', samoletAuthConfig.grantType.code);
  formData.append('client_id', params.config.clientId);
  formData.append('redirect_uri', params.config.urls.getRedirectCompleteUrl());
  formData.append('code', params.code);
  formData.append('code_verifier', params.verifier);

  const { data } = await authApiClient.post(
    params.config.urls.getAuthTokenUrl(),
    formData,
  );

  return data;
}
